var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BaseService } from 'app/views/base.service';
import { DataProvider2, DataProviderFactory } from "app/provider/data2.provider";
var SitesService = /** @class */ (function (_super) {
    __extends(SitesService, _super);
    function SitesService(http, dp2, dpf) {
        var _this = _super.call(this, http) || this;
        _this.http = http;
        _this.dp2 = dp2;
        _this.dpf = dpf;
        _this.widget = _this.dpf.getNew('widget');
        _this.publishedSite = _this.dpf.getNew('published_site');
        _this.siteAction = _this.dpf.getNew('site/action');
        _this.loadStat = _this.dpf.getNew('load_stat');
        _this.mx = _this.dpf.getNew('mx');
        _this.siteTop = _this.dpf.getNew('site_top');
        _this.widgetSearch = _this.dpf.getNew('widget_search');
        _this.categoryDynamics = _this.dpf.getNew('category_dynamics');
        _this.siteCategories = _this.dpf.getNew('site_categories');
        return _this;
    }
    SitesService.prototype.getTransactionByQuery = function (query) {
        return this.dp2.get('/transaction', query).pipe(map(function (transactions) { return transactions; }));
    };
    SitesService.prototype.returnPaid = function (siteId, data) {
        return this.dp2.post("/support/negotiator/sites/" + siteId + "/returnPaid", data);
    };
    return SitesService;
}(BaseService));
export { SitesService };
